import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { toolboxComponentsMap } from "../../blocks/toolboxComponentsMap";

/**
 * sealy MattressFilterListPage (PLP) body assembly (#33585). The page's
 * StreamField is EXACTLY the ``Toolbox``
 * (``MattressFilterListPageBodyContent`` adds nothing), so the shared map
 * dispatches every key. The hero section (plain model fields) and the
 * trailing store locator render in the full-document
 * MattressFilterListPageTemplate around this body.
 *
 * WRAPPER PARITY (load-bearing): the legacy template rendered
 * ``{{ self.body }}`` -- the whole-field render -- so Wagtail's
 * ``StreamBlock.render_basic`` wrapped every top-level block in
 * ``<div class="w-block-{type} block-{type}">``. One wrapper per top-level
 * block is reproduced here, classes verbatim (the Generic/Basic assembly
 * pattern; contrast the Product/Reviews/Utility assemblies, whose legacy
 * templates used bare ``{% for %}`` loops and therefore render
 * ``React.Fragment``).
 */
export const MattressFilterListPageBody = (
    props: Immutable<{
        page: templates.MattressFilterListPageTemplate["page"];
    }>,
): React.JSX.Element => {
    // `body` is non-null (the model field is `blank=True` without
    // `null=True`); an empty stream renders nothing.
    return (
        <>
            {props.page.body.value.map((block) => (
                <StreamField
                    key={block.id}
                    tagName="div"
                    attrs={{
                        className: `w-block-${block.type} block-${block.type}`,
                    }}
                    value={[block]}
                    components={toolboxComponentsMap}
                />
            ))}
        </>
    );
};
